import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { Family } from '../../api/models';

export type TABLE_TYPE = Table<Family>;

export const TABLE = 'family';
const SCHEMA = 'familyId, sortId';

class FamilyDatabase implements DataRepository<Family> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  // common methods:
  get(key: Key): Promise<Family | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: Family, key: Key): Promise<Family> {
    return this.db[TABLE].put(payload, key);
  }

  bulkAdd(payload: Family[]): Promise<Family[]> {
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<Family[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const FamilyDB = new FamilyDatabase(db);
